<template>
  <div class="solutionContent">
    <div class="headercont">
      <img
        src="../../assets/img/solute/banner1.png"
        alt=""
        style="width:100%;height: 100%;vertical-align:middle;object-fit:contain;;"
      />
      <div class="betweencenter">
        <div class="real">
          <div class="tis bigcolor">{{$t('cloudSolution.title')}}</div>
          <div class="tixt middlecolorc">
            {{$t('cloudSolution.text')}}
          </div>
        </div>
      </div>
    </div>
    <div style="margin:100px 0;">
      <h1>{{$t('cloudSolution.header')}}</h1>
      <div class="botcolor">Hybrid cloud solutions</div>
      <div class="colors matter">{{ $t('cloudSolution.master') }}</div>
    </div>
    <div class="solution">
      <!-- 业务需求 -->
      <div class="buisnessrequire">
        <div class="buisnesstext">
          <h1>{{ $t('cloudSolution.businessRequire') }}</h1>
          <ul style="margin-top:60px;">
            <li
              v-for="(item, index) in $t('cloudSolution.businessList')"
              :key="index"
              class="colors hes"
              :title="item.name"
            >
              • {{ item.name |ellipsis}}
            </li>
          </ul>
          <h1 style="margin-top:60px;">{{ $t('cloudSolution.solutions') }}</h1>
          <ul style="margin-top:60px;">
            <li
              v-for="(item, index) in $t('cloudSolution.solutionList')"
              class="colors hes"
              :key="index"
              :title="item.name"
            >
              • {{ item.name|ellipsis }}
            </li>
          </ul>
        </div>
        <div class="buisness">
          <img src="../../assets/img/solute/hunhe.png" alt="" />
        </div>
      </div>
    </div>
    <div class="advantage">
      <!-- 优势 -->
      <div style="margin:77px 0 20px 0;">
        <h1>{{ $t('cloudSolution.advantage') }}</h1>
        <div class="botcolor">Advantage</div>
      </div>
      <div class="contentcase">
        <div class="navs">
          <div v-for="(item, it) in $t('cloudSolution.textlist')" :key="it" class="list">
            <img
              :src="item.img"
              alt=""
              class="imgtop"
              @click="tapcase(item.type)"
            />
            <div class="bottom clearfix" @click="tapcase(item.type)">
              <div @click="tapcase(item.type)">
                <p class="middlecolors fontw">
                  {{ item.name }}
                </p>
                <p class="colors" style="margin-top:10px;" :title="item.title">
                  {{ item.title |ellipsis}}
                </p>
              </div>
              <div class="btn"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="solution">
      <!-- 服务 -->
      <div class="oneserve">
        <div style="padding:60px 0;">
          <h1>{{ $t('cloudSolution.serve') }}</h1>
          <div class="colors matter">{{ $t('cloudSolution.matterservice') }}</div>
        </div>
        <div class="services">
          <div class="headerTitle">
            <div
              class="fontws"
              :class="tapflag ? 'active' : 'one'"
              @click="tapphone"
            >
              <div class="imgwidth">
                <img :src="mixedlinesimg" alt="" />
              </div>
              <span class="fontw middlecolors fonttop">{{$t('cloudSolution.mixtureline')}}</span>
            </div>
            <div
              class="fontws"
              :class="tapflags ? 'actives' : 'two'"
              @click="tapemail"
            >
              <div class="imgwidth">
                <img :src="mixedcloudimg" alt="" />
              </div>

              <span class="fontw middlecolors fonttop">{{$t('cloudSolution.mixturezoo')}}</span>
            </div>
          </div>
          <div class="mixture">
            <div class="formsign colors">{{$t('cloudSolution.mixedcoud')}}</div>
            <div class="formsign colors">{{ $t('cloudSolution.ecology') }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      textlist: [
        {
          name: "可用性",
          img: require("../../assets/img/solute/01.png"),
          title:
            "云计算并不能保证服务永远正常，但公有云通常会比大多数本地基础设施具有更高的可用性。云内置有冗余功能并提供关键数据的geo-replication",
          type: 1
        },
        {
          name: "敏捷性",
          img: require("../../assets/img/solute/02.png"),
          title:
            "混合云使您能够将资源和工作负载从本地迁移到云，反之亦然。对于开发和测试而言，混合云使开发人员能够轻松搞定新的虚拟机和应用程序，而无需IT运维人员的协助",
          type: 2
        },
        {
          name: "降低成本",
          img: require("../../assets/img/solute/03.png"),
          title:
            "降低成本是云计算最吸引人的优势之一，也是驱使企业管理层考虑云服务的重要因素。混合云可以帮助企业降低成本，利用“即用即付”云计算资源来消除购买本地资源的需求",
          type: 3
        },

        {
          name: "可扩展性",
          img: require("../../assets/img/solute/04.png"),
          title:
            "混合云为企业扩展存储提供了经济高效的方式，云存储的成本相比等量本地存储要低得多，是备份、复制VM和数据归档的不错选择。除此之外，增加云存储没有前置成本和本地资源需求",
          type: 4
        }
      ],
      title: "简介",
      matter:
        "依托天弛网络云连接的公有云、数据中心等混合云产品，提供混合云基础设施的设计、部署实施、安全管理和智能运维的全生命周期服务，帮助企业轻松快速搭建自己所需要的混合云架构。",
      solutions: "解决方案",
      solutionList: [
        {
          name:
            "基于天弛云专线的公有云集群，深度融合天弛网络的连接能力、混合云产品服务能力，打造混合云产业新生态，助力数据容灾备份解决方案等的快速落地"
        },
        {
          name:
            "为企业提供混合云基础设施设计、部署与实施、安全与智能运维的全生命周期服务，使企业轻松快速定制混合云方案"
        }
      ],
      businessRequire: "业务需求",
      businessList: [
        {
          name: "实现公有云与数据中心、私有云等不同资源的高效互通"
        },
        {
          name:
            "将中心化的公有云资源与能力实现本地化，提高计算效率，从而提升应用体验"
        },
        {
          name:
            "混合云网络架构较为复杂，简化混合云基础设施的落地过程，且对网络质量的要求较高"
        }
      ],
      advantage: "优势",
      serve: "一站式混合云服务",
      matterservice:
        "天弛提供专业的业务咨询、数据中心托管、专线网络互联、互联网带宽、硬件代购及代维等服务，满足不同行业的网络需求，一站式解决企业的网络困扰",
      mixedcoud:
        "通过调用API，在天弛SDN高可用网络中实现公有云之间的互联，无需线下操作，即可实现混合云私有网络的敏捷交付，此外，还可实现企业、数据中心与云的快速连接",
      ecology:
        "天弛网内连接主流云服务商，并与阿里云、腾讯云等公有云服务商合作深度定制混合云完整解决方案",
      tapflag: true,
      tapflags: false,
      mixedcloudimg: require("../../assets/img/solute/mixedcloud.png"),
      mixedlinesimg: require("../../assets/img/solute/mixedlines.png")
    };
  },
  methods: {
    tapphone() {
      this.tapflag = true;
      this.tapflags = false;
    },
    tapemail() {
      this.tapflag = false;
      this.tapflags = true;
      console.log(this.tapflags);
    }
  }
};
</script>
<style lang="scss" scoped>
.solutionContent {
  width: 100%;
  margin: 0 auto;
  .matter {
    margin: auto;
    width: 629px;
    line-height: 27px;
    text-align: center;
    margin-top: 20px;
  }
  .headercont {
    position: relative;
    .betweencenter {
      width: 1200px;
      margin: 0 auto;
      .real {
        position: absolute;
        top: 150px;
        z-index: 1000;
        text-align: left;
        .tis {
          // width: 420px;
          letter-spacing: 0px;
          line-height: 16px;
          font-size: 48px;
        }
        .tixt {
          width: 420px;
          margin-top: 36px;
          line-height: 23px;
          letter-spacing: 1px;
        }
      }
    }
  }

  .solution {
    width: 100%;
    background-color: #f4f4f4;
    // 业务需求
    .buisnessrequire {
      width: 1200px;
      // height: 859px;
      margin: 0 auto;
      display: flex;
      justify-content: space-between;
      padding: 100px 0;
      box-sizing: border-box;
      position: relative;
      .buisness {
        width: 100%;
        height: 100%;
        img {
          width: auto;
          height: auto;
          max-width: 100%;
          max-height: 100%;
        }
      }
      .buisnesstext {
        text-align: left;
        box-sizing: border-box;
        .hes {
          width: 467px;
          line-height: 30px;
          box-sizing: border-box;
        }
      }
    }
    // 服务
    .oneserve {
      width: 1200px;
      margin: 0 auto;
      box-sizing: border-box;
      margin-top: 80px;
      padding-bottom: 80px;
      .matter {
        margin: auto;
        width: 917px;
        line-height: 27px;
        text-align: center;
        margin-top: 20px;
      }
      .services {
        width: 100%;
        .headerTitle {
          width: 100%;
          height: 150px;
          text-align: center;
          border-bottom: solid 1px #cccccc;
          display: flex;
          justify-content: center;
          align-items: center;
          cursor: pointer;
          .fontws {
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            .imgwidth {
              height: 100px;
              width: 100%;
            }
            img {
              height: 100%;
              vertical-align: middle;
            }
            .fonttop {
              margin: 20px 0 25px 0;
            }
          }

          .one {
            width: 50%;
            height: 100%;
            font-size: 16px;
          }
          .two {
            width: 50%;
            height: 100%;
            font-size: 16px;
          }
          .active {
            width: 50%;
            height: 100%;
            background: url("../../assets/img/main/cursor.png") no-repeat bottom
              center;
            background-size: 186px 11px;
            font-size: 16px;
          }
          .actives {
            width: 50%;
            height: 100%;
            background: url("../../assets/img/main/cursor.png") no-repeat bottom
              center;
            background-size: 186px 11px;
            font-size: 16px;
          }
        }
        .mixture {
          display: flex;
          justify-content: space-between;
          margin-top: 40px;
          padding: 0 20px;
          box-sizing: border-box;
          .formsign {
            width: 45%;
            text-align: left;
          }
        }
      }
    }
  }
  .advantage {
    width: 1200px;
    margin: 0 auto;
    // 优势
    .contentcase {
      .navs {
        width: 100%;
        height: 100%;
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;
        .list {
          width: 590px;
          height: 470px;
          margin-bottom: 30px;
          .el-card {
            width: 100% !important;
            height: 100% !important;
          }
          .el-card__body {
            box-sizing: border-box;
            width: 100% !important;
            height: 100% !important;
          }
          .imgtop {
            max-width: 590px;
            max-height: 300px;
            vertical-align: middle;
          }
          .bottom {
            margin-top: 20px;
            box-sizing: border-box;
            padding: 22px 37px 34px 28px;
            text-align: left;
            display: flex;
            justify-content: space-between;
            border: 1px solid #248f47;
            height: 163px;
          }
          .bottom:hover {
            background: #248f47;
            .middlecolors {
              font-size: 16px !important;
              color: #fff !important;
            }
            .colors {
              font-size: 16px !important;
              color: #fff !important;
            }
          }
          .clearfix:before,
          .clearfix:after {
            display: table;
            content: "";
          }

          .clearfix:after {
            clear: both;
          }
        }
      }
    }
  }
}
</style>
